// Analytics utility for tracking user interactions
class Analytics {
  static async trackEvent(action, value, data = {}) {
    try {
      const payload = {
        action,
        value,
        data: {
          ...data
        },
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString()
      };

      await fetch('/api/analytics', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });
    } catch (error) {
      console.error('Analytics tracking error:', error);
    }
  }

  // Track page views
  static trackPageView(pageName) {
    this.trackEvent('page_view', pageName);
  }

  // Track CV opens
  static trackCVOpen() {
    this.trackEvent('cv_open', 'cv_page');
  }

  // Track CV downloads
  static trackCVDownload() {
    this.trackEvent('cv_download', 'cv_pdf');
  }

  // Track experience clicks
  static trackExperienceClick(experienceName) {
    this.trackEvent('experience_click', experienceName);
  }

  // Track contact form submissions
  static trackContactSubmit() {
    this.trackEvent('contact_submit', 'contact_form');
  }

  // Track project clicks (for GitHub projects)
  static trackProjectClick(projectName) {
    this.trackEvent('project_click', projectName);
  }

  // Track custom events with value and data
  static trackCustomEvent(action, value, data = {}) {
    this.trackEvent(action, value, data);
  }
}

export default Analytics;
